var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.931C0 4.446 4.446 0 9.931 0c5.485 0 9.931 4.446 9.931 9.931 0 5.485-4.446 9.931-9.931 9.931C4.446 19.862 0 15.416 0 9.931zm9.931-.497a3.476 3.476 0 110-6.951 3.476 3.476 0 010 6.951zm0-5.958a2.482 2.482 0 100 4.965 2.482 2.482 0 000-4.965zm0-2.483a8.938 8.938 0 017.399 13.935c-1.608-2.429-4.321-3.984-7.399-3.984a8.929 8.929 0 00-7.399 3.922c-.963-1.364-1.526-3.084-1.526-4.935 0-4.932 3.995-8.93 8.925-8.938zm-6.763 14.76a8.92 8.92 0 006.763 3.116 8.772 8.772 0 006.763-3.162 7.938 7.938 0 00-6.758-3.766c-2.855 0-5.358 1.506-6.768 3.812z"
  })));
}
export default SvgIconUser;